import ResourceService from "./resource.service";

class NewsletterService extends ResourceService {
  static get resource() {
    return "admin/newsletter";
  }
}
export default NewsletterService;